module.exports = __webpack_public_path__ + "static/media/black@3x.867c6266.png";